import {
  SearchableDropdown,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@frontend/ui'

// Sentinels for the two Select dropdowns. Distinct strings because the
// position filter's "no filter" state is `''` (empty string) while the
// drill filter's is `null` — keeping them separate avoids collapsing
// those two semantics.
const ALL_POSITIONS_VALUE = '__all__'
const ALL_DRILLS_VALUE = 'all'

interface PlayerDetailFilterBarProps {
  playerOptions: { value: string; name: string }[]
  activePlayerId: string
  onPlayerChange: (id: string) => void

  drillOptions: { value: string; label: string }[]
  selectedDrillId: string | null
  onDrillChange: (id: string | null) => void

  positionFilter: string
  positionOptions: { value: string; label: string }[]
  onPositionChange: (value: string) => void
}

export function PlayerDetailFilterBar({
  playerOptions,
  activePlayerId,
  onPlayerChange,
  drillOptions,
  selectedDrillId,
  onDrillChange,
  positionFilter,
  positionOptions,
  onPositionChange
}: PlayerDetailFilterBarProps) {
  return (
    <div className='flex flex-wrap items-center gap-2'>
      <Select
        value={positionFilter || ALL_POSITIONS_VALUE}
        onValueChange={(v) =>
          onPositionChange(v === ALL_POSITIONS_VALUE ? '' : v)
        }
      >
        <SelectTrigger className='w-36'>
          <SelectValue placeholder='All positions' />
        </SelectTrigger>
        <SelectContent>
          {positionOptions.map((pos) => (
            <SelectItem
              key={pos.value || ALL_POSITIONS_VALUE}
              value={pos.value || ALL_POSITIONS_VALUE}
            >
              {pos.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <SearchableDropdown
        options={playerOptions}
        value={activePlayerId}
        onSelect={(v) => onPlayerChange(v.toString())}
        placeholder='Select player…'
        searchPlaceholder='Search players…'
        className='w-40'
        clearButton={false}
      />

      {drillOptions.length > 0 && (
        <Select
          value={selectedDrillId ?? ALL_DRILLS_VALUE}
          onValueChange={(v) =>
            onDrillChange(v === ALL_DRILLS_VALUE ? null : v)
          }
        >
          {/* Auto-width so long drill names ("Possession — half-pitch" etc.)
              don't clip at the old fixed 7rem. */}
          <SelectTrigger className='w-auto min-w-28'>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL_DRILLS_VALUE}>All drills</SelectItem>
            {drillOptions.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  )
}
